import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { ChatMessage } from "../types";
import { AIChatAssistantFrame } from "./AIChatAssistantFrame";

type Props = {
  message: ChatMessage;
};

export function AIChatTableMessage({ message }: Props) {
  const table = message.table;
  if (!table) return null;

  return (
    <AIChatAssistantFrame message={message} wide>
      {message.intro ? (
        <p className="mb-3 whitespace-pre-wrap text-sm leading-6 text-[#374151]">
          {message.intro}
        </p>
      ) : null}
      <Table className="min-w-max">
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            {table.headers.map((header) => (
              <TableHead
                key={header}
                className="bg-[#F9FAFB] text-xs font-semibold text-[#6B7280]"
              >
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {table.rows.map((row, rowIndex) => (
            <TableRow key={`${message.id}-row-${rowIndex}`}>
              {row.map((cell, cellIndex) => (
                <TableCell
                  key={`${message.id}-cell-${rowIndex}-${cellIndex}`}
                  className="whitespace-nowrap text-[#111827]"
                >
                  {cell || "—"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </AIChatAssistantFrame>
  );
}
